<template>
  <div class="ccs-layout">
    <modal :title="'Новая позиция'" :subtitle="''"
      @close="switchModal"
      v-if="modal">
      <unit @close="switchModal" @submit="addUnit" isPackageCreation/>
    </modal>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" type="text" label="Наименование пакета"
        v-model.trim="pkg.name" placeholder="Введите наименование" />
      <ccs-input class="ccs-6" type="text" label="Стоимость пакета"
        v-model.trim="pkg.price" placeholder="Введите стоимость" imgAlt="руб"/>
      <ccs-input class="ccs-6" type="text" label="Стоимость дополнительного дня"
        v-model.trim="pkg.additional_price" placeholder="Введите стоимость" imgAlt="руб"/>
      <ccs-input class="ccs-6" type="date" label="Дата начала действия пакета"
        v-model.trim="pkg.started_at" placeholder="Введите стоимость"/>
      <ccs-input class="ccs-6" type="date" label="Дата окончания действия пакета"
        v-model.trim="pkg.expired_at" placeholder="Введите стоимость"/>
    </div>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-9" type="autocomplete" label="Роль назначения (для кого доступен пакет)"
        v-model="roleID" @change="onRoleSearch" placeholder="Введите 3 символа для поиска"
        :items="rolesForSelect"/>
      <div class="ccs-3 button--add">
        <button class="ccs-button ccs-button--small ccs-12" @click="addRole">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12">
        <div class="ccs-tag ccs-tag--normal" v-for="(role, index) in pkg.roles" :key="index">
          {{ `#${role.name}` }}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad modal-table">
      <div class="ccs-12 ccs-subtitle">
        Содержимое пакета
      </div>
      <div class="ccs-12">
        <ccs-table :data="pkg.units" :columnsDefs="columnsDefs" :defaultActions="defaultActions"
          :options="tableOptions" @delete="deleteUnit"/>
        <div>
          <button class="ccs-button ccs-button--white ccs-button--no-border" @click="switchModal">
            <img src="@/assets/icons/add.svg" alt="" class="button-icon">
            Добавить позицию
          </button>
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить и добавить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Modal from '../../Modal.vue';
import Unit from './Unit.vue';
import Table from '@/components/Table.vue';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Package',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
    'ccs-table': Table,
    Modal,
    Unit,
  },
  data() {
    return {
      roleID: undefined,
      rolesForSelect: [],
      pkg: {
        name: '',
        price: '',
        additional_price: '',
        started_at: new Date(),
        expired_at: new Date(),
        units: [],
        roles: [],
      },
      modal: false,
      columnsDefs: [
        {
          name: `name`,
          title: 'Наименование позиции',
          prop: 'name',
          type: 'text',
        },
        {
          name: `description`,
          title: `Описание`,
          prop: `description`,
          type: 'text',
        },
      ],
      tableOptions: {
        hideBottomBorder: true,
        hideEmptyText: true,
      },
      defaultActions: {
        delete: true,
      },
    };
  },
  computed: {
    ...mapState('events', ['event']),
  },
  methods: {
    ...mapActions('packages', ['createPackage', 'updatePackage', 'addRoleToPackage', 'deleteRoleFromPackage']),
    switchModal() {
      this.modal = !this.modal;
    },
    addUnit(unit) {
      this.pkg.units.push(unit);
    },
    editUnit(unit, index) {
      this.pkg.units[index] = Object.assign({}, unit);
    },
    deleteUnit(unit, index) {
      this.pkg.units.splice(index, 1);
    },
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/events/roles/list', text);
    },
    async addRole() {
      if (this.roleID) {
        const role = this.rolesForSelect.find(item => item.prop === this.roleID);
        this.pkg.roles.push({
          id: role.prop,
          name: role.text,
        });
        this.roleID = undefined;
      }
    },
    async removeRole(role) {
      this.pkg.roles = this.pkg.roles.filter(item => item.id !== role.id);
    },
    async submit() {
      if (this.pkg.id) {
        await this.editPackage();
      } else {
        await this.addPackage();
      }
    },
    async addPackage() {
      try {
        if (this.pkg.roles.length !== 0) {
          this.pkg.event_roles = this.pkg.roles.map(role => role.id);
        }
        this.pkg.event_id = Number(this.event.id);
        await this.createPackage(this.pkg);
        this.$toasted.success('Пакет добавлен');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async editPackage() {
      try {
        await this.updatePackage(this.pkg);
        this.$toasted.success('Изменения сохранены');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ccs-table {
  margin-top: 10px;
}

.button--add {
  margin-top: 20px;
}

.modal-table {
  margin-top: 30px;
}
</style>